<div class="flex flex-wrap mt-8 mb-6">

    @let user = (user$ | async);
    @let myRoles = (myRoles$ |async);
    @let loading = (loading$ | async) ?? false;

    <div class="w-full flex flex-row justify-between mb-4">
        <app-btn-back routeTo=".."></app-btn-back>
        @if (myRoles?.management || (myRoles.faculty && assignment?.gradeId === group?.gradeId)) {
        <div class="flex flex-no-wrap justify-end gap-2">
            <app-btn-action label="Publish" [inProgress]="loading" [isDisabled]="loading" (clicked)="onPublish()"
                icon="fa fa-upload"></app-btn-action>
        </div>
        }
    </div>

    <div class="mb-4 border-0 w-full">
        <h1 class="font-semibold text-2xl capitalize text-primary-500">
            {{ assignment?.lessonName }}
        </h1>
    </div>

    <div class="rounded-t block w-full overflow-x-auto shadow-lg rounded bg-white">
        @if(myRoles?.management || myRoles?.faculty || assignment?.createdById === user?.uid) {
        <rich-text-editor [jsonFormat]="htmlData" (contentChanged)="onContentChanged($event)"
            [isEditable]="(myRoles?.management || myRoles?.faculty || assignment?.createdById === user?.uid)"
            class="w-full"></rich-text-editor>
        } @else {
        <span class="text-primary text-sm font-semibold">Not Authorized</span>
        }
    </div>
</div>